<script setup>
import { ref, onMounted, onUnmounted } from "vue"
import ImgLogo from "@/assets/talento_agv/img/dashboard_postulante/logo_default_with_text.svg"
import ImgUser from "@/assets/talento_agv/img/dashboard_postulante/user_default.png"

import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

const { locale } = useI18n()
const store = useStore()
const emit = defineEmits(["on-change-main-page"])
const id_applicant = JSON.parse(localStorage.getItem('userData'))?.id_usuario

const isScrolled = ref(false)
const isMobileMenuOpen = ref(false)
const textLenguage = ref("ES")
const userData = ref({
  username: 'u.us',
  email: 'correo@gmail.com',
  nombres: 'Nombre',
  ap_paterno: 'Apellido',
  ap_materno: 'Segundo',
  photo: null,
})

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
}

const closeMobileMenu = () => {
  isMobileMenuOpen.value = false;
}

const changeLanguage = async (language) => {
  textLenguage.value = language.toUpperCase();
  await store.dispatch("changePublicLanguage", language);
  locale.value = language;
  emit("on-change-main-page");
}

const signOut = () => {
  localStorage.clear()
}

// Lifecycle hooks and dependent methods
const handleScroll = () => {
  isScrolled.value = window.scrollY > 50;
}

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
})

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
})

</script>
<template>
    <header :class="['navbar-main', { scrolled: isScrolled }]">
        <div
            class="container d-flex justify-content-between align-items-center py-1"
        >
            <!-- Logo -->
            <router-link to="/" class="nav_logo">
            <img
            class="logo-white-filter"
            :src="ImgLogo"
            alt="Logo"
            style="width: 140px;"
            />
            </router-link>

            <!-- Icon -->
            <button
            class="navbar-toggler d-lg-none border-0 bg-transparent"
            type="button"
            @click="toggleMobileMenu"
            >
            <i class="bx bx-menu fs-3 text-white"></i>
            </button>

            <!-- Navigation for desktop -->
            <nav
            class="d-none d-lg-flex gap-4 align-items-center text-white fw-semibold"
            >
              <router-link to="/" class="nav-link text-white">
                  {{ $t("Inicio") }}
              </router-link>

              <div class="dropdown">
                  <button
                  class="btn btn-sm text-white dropdown-toggle"
                  data-bs-toggle="dropdown"
                  >
                  {{ textLenguage }}
                  </button>
                  <ul class="dropdown-menu">
                    <li @click="changeLanguage('es')">
                        <a class="dropdown-item"> ES | Español</a>
                    </li>
                    <li @click="changeLanguage('en')">
                        <a class="dropdown-item">EN | English</a>
                    </li>
                  </ul>
              </div>

              <div v-if="!id_applicant">
                <router-link
                    to="/login"
                    :class="[
                    'btn',
                    isScrolled ? 'btn-local-login active' : 'btn-local-login',
                    'rounded-pill',
                    'px-3',
                    ]"
                >
                    {{ $t("Iniciar Sesión") }}
                </router-link>
              </div>
              
              <div v-else class="nav-item dropdown has-arrow main-drop float-end">
                <a href="javascript:;" class="dropdown-toggle nav-link" data-bs-toggle="dropdown">
                <span class="user-img" style="background-color: white; border-radius: 50%;">
                    <img :src="ImgUser" alt="Image" />
                    <span class="status online"></span>
                </span>
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/datos_personales"
                        ><i class="feather feather-user me-1"></i> Mi Perfil</router-link
                    >
                    <router-link
                    class="dropdown-item"
                    to="/login"
                    @click="signOut"
                    >
                        <i class="feather feather-log-out me-1"></i> 
                        Cerrar Sesión
                    </router-link>
                </div>
            </div>

            </nav>
        </div>

        <!-- Navigation for Mobile -->
        <div v-if="isMobileMenuOpen" class="mobile-nav d-lg-none">
            <div class="container d-flex flex-column gap-3 py-3">
            <router-link to="/" class="nav-link text-white">
                {{ $t("Inicio") }}
            </router-link>
            <router-link
                to="/login"
                class="btn btn-light rounded-pill"
                @click="closeMobileMenu"
            >
                {{ $t("Iniciar Sesión") }}
            </router-link>
            </div>
        </div>
    </header>
</template>
<style scoped>
.logo-white-filter {
    filter: brightness(0) invert(1) !important;
}

.navbar-main {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  transition: background-color 0.3s ease;
  background-color: transparent;
  z-index: 1000;
}

.navbar-main.scrolled {
  background-color: var(--bg-primary-as);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.nav-link {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  text-decoration: none;
}

.mobile-nav {
  background-color: var(--bg-primary-as);
  position: absolute;
  top: 100%;
  width: 100%;
}

.btn-local-login {
  background-color: var(--bg-primary-as);
  color: #fff;
  border: 1px solid transparent;
}
.btn-local-login.active {
  background-color: var(--bg-primary-as-light);
  border: 1px solid transparent;
}
.btn-local-login:hover {
  background-color: var(--bg-primary-as);
}
.btn-local-login.active:hover {
  background-color: var(--bg-primary-as-light);
}

</style>
